export const TrackerObjectiveValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text',
  RUBRIC_A_TO_F: 'rubric_a_to_f',
  CUSTOM: 'custom',
  PERFORMANCE: 'performance'
};

export const AssignmentStatusOptions = {
  ASSIGNED: 'assigned',
  REVISE: 'revise',
  SUBMITTED: 'submitted',
  COMPLETE: 'complete'
};

export const AssignmentTaskValueTypes = {
  CHECKBOX: 'checkbox',
  CHECK_GRADE: 'check_grade',
  RUBRIC_ZERO_FOUR: 'rubric_zero_four',
  NUMBER: 'number',
  TEXT: 'text',
  RUBRIC_A_TO_F: 'rubric_a_to_f',
  CUSTOM: 'custom',
  PERFORMANCE: 'performance'
};

export const AssignmentTaskValueTypeValueRange = {
  [AssignmentTaskValueTypes.RUBRIC_ZERO_FOUR]: [0, 1, 2, 3, 4],
  [AssignmentTaskValueTypes.RUBRIC_A_TO_F]: ['A', 'B', 'C', 'D', 'F'],
  [AssignmentTaskValueTypes.PERFORMANCE]: [
    'beginning',
    'approaching',
    'proficient',
    'excelling'
  ]
};

export const AssignmentDepthOptions = {
  TASK: 1,
  CRITERIA: 2
};

export const ASSIGNMENT_CREATE_STEPS = {
  CREATE: 'create',
  PREPARE: 'prepare',
  REVIEW: 'review'
};

export const ASSIGNMENT_CREATE_MODES = {
  SCRATCH: 'scratch',
  TEMPLATE: 'template'
};

// TODO: replace mock templates
export const MOCK_TEMPLATES = [
  {
    id: 1,
    name: 'Assignment Name 19 Exit Ticket',
    curriculum: 'CURRICULUM NAME',
    grade: 'GRADE 5',
    teacher: 'TEACHER NAME'
  },
  {
    id: 2,
    name: 'Assignment Name Long Name Practice',
    curriculum: 'CURRICULUM NAME',
    grade: 'GRADE 5',
    teacher: 'TEACHER NAME'
  },
  {
    id: 3,
    name: 'Assignment Name Review Session',
    curriculum: 'CURRICULUM NAME',
    grade: 'GRADE 5',
    teacher: 'TEACHER NAME'
  },
  {
    id: 4,
    name: 'Assignment Name Concept Check',
    curriculum: 'CURRICULUM NAME',
    grade: 'GRADE 5',
    teacher: 'TEACHER NAME'
  }
];

export const IS_ACCELERATED_CURRICULUM_FILTER = 'isAcceleratedCurriculumFilter';
